export default __webpack_public_path__ + "8c297c99b6d084b8d38b09c4aad2e9e3.png";